import Main from '@/views/main.vue'

import {certificatelistMenuRouter} from './certificatelist'

const certificateMenuRouter = {
  has: 'finishCertificate',
  path: '/',
  icon: 'android-people',
  name: 'certificateMenuRouter',
  title: '竣工合格证',
  component: Main,
  children: [
    ...certificatelistMenuRouter
  ]
}

export {certificateMenuRouter}



// WEBPACK FOOTER //
// ./src/router/certificate/index.js